import { render, staticRenderFns } from "./statementedManager.vue?vue&type=template&id=c32308c8&scoped=true&"
import script from "./statementedManager.vue?vue&type=script&lang=ts&"
export * from "./statementedManager.vue?vue&type=script&lang=ts&"
import style0 from "./statementedManager.vue?vue&type=style&index=0&id=c32308c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32308c8",
  null
  
)

export default component.exports